/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState, useRef, useEffect } from 'react'
import { useDrag } from '@use-gesture/react'
import { useLoader, useThree } from '@react-three/fiber'
import { Html } from '@react-three/drei'
import { useDispatch, useSelector } from 'react-redux'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

import { const_var, params } from '../../../../redux/reducers/reducer'
import useOutsideClick from '../../../../hooks/useOutsideClick'
import { Overlap, TrussOverlap } from '../../../../utils/Overlap';

import * as actionCreator from '../../../../action/index';

import DiamondWindowWalkInDoor from './WalkInDoorModel/DiamondWindowWalkInDoor'
import ElevenLiteWalkInDoor from './WalkInDoorModel/ElevenLiteWalkInDoor'
import FiveLitePlanWalkInDoor from './WalkInDoorModel/FiveLitePlanWalkInDoor'
import FiveLiteWalkInDoor from './WalkInDoorModel/FiveLiteWalkInDoor'
import FourLiteWalkInDoor from './WalkInDoorModel/FourLiteWalkInDoor'
import FrenchDoorWalkInDoor from './WalkInDoorModel/FrenchDoorWalkInDoor'
import NineLiteWalkInDoor from './WalkInDoorModel/NineLiteWalkInDoor'
import SixLiteWalkInDoor from './WalkInDoorModel/SixLiteWalkInDoor'
import SolidWalkInDoor from './WalkInDoorModel/SolidWalkInDoor'
import StandardWalkInDoor from './WalkInDoorModel/StandardWalkInDoor'
import WalkInFrameoutDoor from './WalkInDoorModel/WalkInFrameoutDoor'

// double door models
import DoubleDeluxWalkInDoor from './DoubleDoorModel/DoubleDeluxWalkInDoor'
import DoubleSliderDoor from './DoubleDoorModel/DoubleSliderDoor'
import DoubleDoorWalkInDoor from './DoubleDoorModel/DoubleDoorWalkInDoor'
import FifteenLiteDoubleDoorWalkInDoor from './DoubleDoorModel/FifteenLiteDoubleDoorWalkInDoor'
import NineLiteDoubleDoorWalkInDoor from './DoubleDoorModel/NineLiteDoubleDoorWalkInDoor'
import SectionalDoor from './DoubleDoorModel/SectionalDoor'
import SectionalWithWindowDoor from './DoubleDoorModel/SectionalWithWindowDoor'
import SectionalWithPlainWindowDoor from './DoubleDoorModel/SectionalWithPlainWindowDoor'
import SectionalWithSherwoodWindowDoor from './DoubleDoorModel/SectionalWithSherwoodWindowDoor'
import SectionalWithWilliamsburgWindowDoor from './DoubleDoorModel/SectionalWithWilliamsburgWindowDoor'
import SectionalWithCascadeWindowDoor from './DoubleDoorModel/SectionalWithCascadeWindowDoor'
import SectionalWithCathedralWindowDoor from './DoubleDoorModel/SectionalWithCathedralWindowDoor'
import SectionalWithStocktonWindowDoor from './DoubleDoorModel/SectionalWithStocktonWindowDoor'
import SectionalWithStockbridgeWindowDoor from './DoubleDoorModel/SectionalWithStockbridgeWindowDoor'
import SectionalWithPrairieWindowDoor from './DoubleDoorModel/SectionalWithPrairieWindowDoor'
import SectionalWithWatertonWindowDoor from './DoubleDoorModel/SectionalWithWatertonWindowDoor'

import DoorMeasurements from '../../Measurements/DoorWIndowsMeasurement/DoorMeasurements'
import { extrudeSettings, getWallDirOnCanvas, revertPosOfCmp } from '../../../../utils/Functions'
import { addValidation, wallNameArrForValid } from '../../../../utils/Validation'
import { loadDoorComponentOnWall, wallnameBySec } from '../../../../redux/reducers/componentReducer'

// import StandardDoor from './DoubleDoorModel/StandardDoor'
import RollUpDoor from './DoubleDoorModel/RollUpDoor'
import GarageDoorFrameoutDoor from './DoubleDoorModel/GarageDoorFrameoutDoor'
import RollUpDoorDegree from './DoubleDoorModel/RollUpDoorDegree'
import GarageDoorFrameoutDoorDegree from './DoubleDoorModel/GarageDoorFrameoutDoorDegree'
import DoorOutLineSection from '../OutLineModel/DoorOutLineSection'
// import AnimButton from '../../../Button/AnimButton'
import { getPosition } from '../../../../utils/GetToolTipPosition'
import NineLitePlainWalkInDoor from './WalkInDoorModel/NineLitePlainWalkInDoor'
import { controls } from '../../../../redux/reducers/eventReducer'
import useMouseEvents from '../../../../hooks/useMouseEvents'
import NineLitePanelWalkInDoor from './WalkInDoorModel/NineLitePanelWalkInDoor'

const DoorModel = ({
    id,
    wallName,
    compName,
    compType,
    width,
    height,
    defaultPositionX,
    defaultPositionY,
    trimWidth,
    doorColor,
    overlapTrimColor,
    glassTexture,
    overlapDoorArr,
    setOverlapDoorArr,
    overlapTrussArr,
    setOverlapTrussArr,
}) => {
    const editRef = useRef();
    const dispatch = useDispatch();    
    const get = useThree((state) => state.get)
    const mainTrussPosInfo = useSelector(state => state.reducer.mainTrussPosInfo)
    const leanToTrussPosInfo = useSelector(state => state.reducer.leanToTrussPosInfo)
    const isShowEditIconSection = useSelector(state => state.reducer.isShowEditIconSection)
    const isotherDoorType = useSelector(state => state.reducer.isotherDoorType)
    const selectedCmpType = useSelector(state => state.reducer.selectedCmpType)
    const backStoragePositionZ = useSelector((state) => state.reducer.backStoragePositionZ);
    const leftLeanStoragePositionZ = useSelector((state) => state.reducer.leftLeanStoragePositionZ);
    const rightLeanStoragePositionZ = useSelector((state) => state.reducer.rightLeanStoragePositionZ);
    const frontLeanStoragePositionX = useSelector((state) => state.reducer.frontLeanStoragePositionX);
    const backLeanStoragePositionX = useSelector((state) => state.reducer.backLeanStoragePositionX);
    
    const [isAvailablePlace, setIsAvailablePlace] = useState(true)
    const [positionX, setPositionX] = useState(defaultPositionX);
    const [positionY, setPositionY] = useState(defaultPositionY);
    const [startPositionXY, setStartPositionXY] = useState({x: defaultPositionX, y: defaultPositionY});
    const [isDrag, setIsDrag] = useState(false);
    // const [opacityValue, setOpacityValue] = useState(1);
    // const [transparentState, setTransparentState] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isDelBtnClicked, setIsDelBtnClicked] = useState(false);
    const [isCloned, setIsCloned] = useState(false);
    const [canClone, setCanClone] = useState(true);
    const [trimColor, setTrimColor] = useState(true);
    const [bindDelta, setBindDelta] = useState([0, 0]);
    const [plane, setPlane] = useState(new THREE.Plane(new THREE.Vector3(0, 0, 1), 0))
    const [ intersect ] = useState(() => new THREE.Vector3());

    const { scene, camera, gl } = useThree();    
    const doorRef = useRef(null);
    const raycaster = new THREE.Raycaster();
    
    // const baseUrl = process.env.REACT_APP_BASE_URL;
    // const handle_1 = useLoader(GLTFLoader, baseUrl+'/assets/glbModels/handle_sphere.glb').nodes;
    // const handle_2 = useLoader(GLTFLoader, baseUrl+'/assets/glbModels/handle_rect_group.glb').nodes;
  
    const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(wallName));
    const sideArray = const_var.newDoorsArray.filter((item) => item.uniqueId !== id && targetWallNameArr.includes(item.userData.wallName));
    const componentDistance = const_var.componentDistance;
    const distance = (const_var.controls!=undefined && const_var.controls != '' && const_var.controls.getDistance!=undefined)? const_var.controls.getDistance([0, 0, 0]):[0, 0, 0];
    const alpha = Math.atan(params.p_r_p / 12);
    const frontLeanAlpha = Math.atan(params.b_l_t_r_pF / 12);
    const backLeanAlpha = Math.atan(params.b_l_t_r_pB / 12);
    const leftLeanAlpha = Math.atan(params.b_l_t_r_p / 12);
    const rightLeanAlpha = Math.atan(params.b_l_t_r_pR / 12);
    const currentAzimuthalAngle = const_var.controls!=undefined && const_var.controls != '' ? const_var.controls.getAzimuthalAngle():0;
    const camAngle = (Math.atan((params.p_d / 2) / (params.p_w / 2)));

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    const calculateOffset = (val, legDistance) => val % legDistance === 0 ? 0.15 : 0;
    const backStorageoffset = calculateOffset(params.p_d, legDistance);
    const frontLeanStorageoffset = calculateOffset(params.leanF_p_d, legDistance);
    const backLeanStorageoffset = calculateOffset(params.leanB_p_d, legDistance);
    const leftLeanStorageoffset = calculateOffset(params.lean_p_d, legDistance);
    const rightLeanStorageoffset = calculateOffset(params.leanR_p_d, legDistance);
    
    const canvasElement = document.getElementsByClassName("building-size")
    const isPattern = (canvasElement != undefined && canvasElement[0] && canvasElement[0].clientWidth > 1050 ) ? true : false

    const legGroup = new THREE.Group()
    legGroup.name = "legGroup"
    scene.add(legGroup)

    const thickness = 0.3

    const checkDoorTransparent = () => {
        let transparentDoor = false
        let door
        if(const_var.scene != undefined && const_var.scene != "") door = const_var.scene.getObjectByName(`${compName}_${wallName}_${id}_DoorWindows`)
        if(door != undefined && door.isTransparent != undefined && door.isTransparent == true){
            transparentDoor = true;
            if(!params.is_translusant){
                door.traverse((mesh)=>{
                    if(mesh.isMesh){
                        mesh.material.opacity = 0.02
                        mesh.material.transparent = true
                        mesh.material.needsUpdate = true
                    }
                })
            }
        }
        return transparentDoor
    }
    const isDoorTransparent = checkDoorTransparent();
    if(controls.isCheckActiveTab != null && controls.isCheckActiveTab == "doorwindow"){
        setTimeout(() => {
            checkDoorTransparent();
        }, 701);
    }

    const limitY = useMemo(() => {
        const trimHeight = 0.2;
        let regularHeight = 0;
        let trimThickness = 0.2;

        if (params.p_r_s === 1) {
            trimThickness = 0.2;
            regularHeight = 0.4;
        } else if (params.p_r_s === 2) {
            trimThickness = 0.2;
            regularHeight = 0;
        } else if (params.p_r_s === 3) {
            trimThickness = 0.05;
            regularHeight = 0;
        }

        const trimOffsetHeight = (params.p_r_p / 12) * trimThickness;

        if (params.singleSlope) {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                return {
                    min: 0,
                    max: params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
                return {
                    min: 0,
                    max: params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight - trimOffsetHeight
                }
            } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
                return {
                    min: 0,
                    max: params.p_h - trimHeight - trimOffsetHeight
                }
            } else if (wallName === 'c_b_l_s_r_w') {
                return {
                    min: 0,
                    max: params.p_h - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12
                }
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                return {
                    min: 0,
                    max: params.p_h - trimHeight - (params.p_w - (parseInt(params.cB_addStorage_left)) + 0.0075) * params.p_r_p / 12 - Math.tan(alpha) * (width + componentDistance * 2)
                }
            } else if (wallName === 'c_b_r_s_l_w') {
                return {
                    min: 0,
                    max: params.p_h - (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12
                }
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                return {
                    min: 0,
                    max: params.p_h - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                }
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                return {
                    min: 0,
                    max: params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2)
                }
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                return {
                    min: 0,
                    max: params.leanR_p_h - trimHeight - trimOffsetHeight,
                }
            }
            else if (wallName === 'R_L_L_S_W') {
                return {
                    min: 0,
                    max: params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w
                }
            }
        } else {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                return {
                    min: 0,
                    max: params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
                return {
                    min: 0,
                    max: params.p_h - trimHeight - trimOffsetHeight,
                }
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_L_W' || wallName === 'F_L_R_S_W') {
                return {
                    min: 0,
                    max: params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight - Math.tan(frontLeanAlpha) * (width + componentDistance * 2)
                }
            } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
                return {
                    min: 0,
                    max: params.leanF_p_h - trimHeight - trimOffsetHeight,
                }
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_B_W' || wallName === 'B_L_L_S_W') {
                return {
                    min: 0,
                    max: params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight - Math.tan(backLeanAlpha) * (width + componentDistance * 2)
                }
            } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
                return {
                    min: 0,
                    max: params.leanB_p_h - trimHeight - trimOffsetHeight,
                }
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_B_W' || wallName === 'R_L_F_S_W') {
                return {
                    min: 0,
                    max: params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight - Math.tan(rightLeanAlpha) * (width + componentDistance * 2)
                }
            } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
                return {
                    min: 0,
                    max: params.leanR_p_h - trimHeight - trimOffsetHeight,
                }
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_B_W' || wallName === 'L_L_F_S_W') {
                return {
                    min: 0,
                    max: params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight - Math.tan(leftLeanAlpha) * (width + componentDistance * 2)
                }
            } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
                return {
                    min: 0,
                    max: params.lean_p_h - trimHeight - trimOffsetHeight,
                }
            } else if (wallName === 'c_b_l_s_r_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_left) < params.p_w / 2) {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + regularHeight;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + regularHeight;
                }
    
                return {
                    min: 0,
                    max: params.p_h + overHeight,
                }
            } else if (wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w') {
                if (parseInt(params.cB_addStorage_left) - params.p_w / 2 < width / 2 + componentDistance) {
                    return {
                        min: 0,
                        max: params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_left) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                    }
                } else {
                    return {
                        min: 0,
                        max: params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                    }
                }
            } else if (wallName === 'c_b_r_s_l_w') {
                let overHeight = 0;
                if (parseInt(params.cB_addStorage_right) < params.p_w / 2) {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + regularHeight;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + regularHeight;
                }
    
                return {
                    min: 0,
                    max: params.p_h + overHeight,
                }
            } else if (wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
                if (parseInt(params.cB_addStorage_right) - params.p_w / 2 < width / 2 + componentDistance) {
                    return {
                        min: 0,
                        max: params.p_h + (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) + regularHeight - trimHeight - Math.tan(alpha) * (width + componentDistance * 2)
                    }
                } else {
                    return {
                        min: 0,
                        max: params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight - Math.tan(alpha) * (width / 2 + componentDistance)
                    }
                }
            } else if (wallName === 'R_L_L_S_W') {
                return {
                    min: 0,
                    max: params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w
                }
            } else if (wallName === 'L_L_R_S_W') {
                return {
                    min: 0,
                    max: params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w
                }
            }
        }
    
    }, [wallName, width, params.singleSlope, params.p_w, params.p_h, params.p_r_s, params.p_r_p, params.leanF_p_h, params.leanF_p_w, params.b_l_t_r_pF, params.leanB_p_h, params.leanB_p_w, params.b_l_t_r_pB, params.leanR_p_h, params.leanR_p_w, params.b_l_t_r_pR, params.lean_p_h, params.lean_p_w, params.b_l_t_r_p, params.cB_addStorage_left, params.cB_addStorage_right]);

    const limitX = useMemo(() => {
        const trimHeight = 0.2;
        let regularHeight = 0;

        if (params.p_r_s === 1) {
            regularHeight = 0.4;
        } else if (params.p_r_s === 2) {
            regularHeight = 0;
        } else if (params.p_r_s === 3) {
            regularHeight = 0;
        }

        if (params.singleSlope) {
            if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    return {
                        min: -(params.p_w / 2 - width / 2 - componentDistance),
                        max: params.p_w / 2- width / 2 - componentDistance
                    }
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    return {
                        min: -minValue + width / 2 + componentDistance,
                        max: params.p_w / 2 - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    return {
                        min: -(params.p_w / 2 - width / 2 - componentDistance),
                        max: params.p_w / 2 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    return {
                        min: -params.p_w / 2 + width / 2 + componentDistance,
                        max: -minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                return {
                    min: -(params.p_d / 2 - width / 2 - componentDistance),
                    max: params.p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'c_b_r_s_w') {
                return {
                    min: -(parseInt(params.p_u_t) - params.p_d / 2) + width / 2 + componentDistance,
                    max: params.p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'c_b_l_s_w') {
                return {
                    min: -(params.p_d / 2 - width / 2 - componentDistance),
                    max: parseInt(params.p_u_t) - params.p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'c_b_l_s_f_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    return {
                        min: -(params.p_w / 2 - width / 2 - componentDistance),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - width / 2 - componentDistance
                    }
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    return {
                        min: -minValue + width / 2 + componentDistance,
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * params.p_w - trimHeight) {
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_left) + width / 2 + componentDistance,
                        max: params.p_w / 2 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_left) + width / 2 + componentDistance,
                        max: -minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_right) + width / 2 + componentDistance,
                        max: params.p_w / 2 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = -params.p_w / 2 + (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    return {
                        min: -minValue + width / 2 + componentDistance,
                        max: params.p_w / 2 - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                const maxHeight = params.p_h - trimHeight;
                if (height <= params.p_h - (params.p_r_p / 12) * parseInt(params.cB_addStorage_right) - trimHeight) {
                    return {
                        min: -(params.p_w / 2 - width / 2 - componentDistance),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_right) - width / 2 - componentDistance
                    }
                } else {
                    const minValue = params.p_w / 2 - (maxHeight - height / 2 - positionY) / Math.tan(alpha);
                    return {
                        min: -params.p_w / 2 + width / 2 + componentDistance,
                        max: -minValue - width / 2 - componentDistance
                    }
                }
            }
            else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2 + width / 2 + componentDistance,
                        max: params.p_w / 2 + params.leanR_p_w - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                    return {
                        min: params.p_w / 2 + width / 2 + componentDistance,
                        max: params.p_w / 2 + minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'R_L_B_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_w / 2 - params.leanR_p_w + width / 2 + componentDistance,
                        max: -params.p_w / 2 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                    return {
                        min: -params.p_w / 2 - minValue + width / 2 + componentDistance,
                        max: -params.p_w / 2 - width / 2 - componentDistance
                    }
                }
            }
            else if (wallName === 'R_L_R_W') {
                return {
                    min: params.add_right_front_lean_porch ? -params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w + width / 2 + componentDistance : -params.leanR_p_pos - params.leanR_p_d / 2 + width / 2 + componentDistance,
                    max: params.add_right_back_lean_porch ? -params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w - width / 2 - componentDistance : -params.leanR_p_pos + params.leanR_p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'R_L_R_S_W') {
                return {
                    min: -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right) + width / 2 + componentDistance,
                    max: -params.leanR_p_pos + params.leanR_p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'R_L_L_S_W') {
                return {
                    min: params.leanR_p_pos - params.leanR_p_d / 2 + width / 2 + componentDistance,
                    max: params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) - width / 2 - componentDistance
                } 
            }
        } else {
            if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_f_s_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: -(params.p_w / 2 - width / 2 - componentDistance),
                        max: params.p_w / 2 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: -(minValue - width / 2 - componentDistance),
                        max: minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_l_w') {
                return {
                    min: -(params.p_d / 2 - width / 2 - componentDistance),
                    max: params.p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'F_L_R_W' || wallName === 'F_L_R_S_W') {
                const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                if (height <= params.leanF_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_d / 2 - 0.15 - params.leanF_p_w + width / 2 + componentDistance,
                        max: -params.p_d / 2 - 0.15 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(frontLeanAlpha);
                    return {
                        min: -params.p_d / 2 - 0.15 - minValue + width / 2 + componentDistance,
                        max: -params.p_d / 2 - 0.15 - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'F_L_L_W') {
                const maxHeight = params.leanF_p_h + (params.b_l_t_r_pF / 12) * params.leanF_p_w + regularHeight - trimHeight;
                if (height <= params.leanF_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_d / 2 + 0.15 + width / 2 + componentDistance,
                        max: params.p_d / 2 + 0.15 + params.leanF_p_w - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(frontLeanAlpha);
                    return {
                        min: params.p_d / 2 + 0.15 + width / 2 + componentDistance,
                        max: params.p_d / 2 + 0.15 + minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'F_L_F_W') {
                return {
                    min: params.add_left_front_lean_porch ? params.leanF_p_pos - params.leanF_p_d / 2 - params.lean_p_w + width / 2 + componentDistance : params.leanF_p_pos - params.leanF_p_d / 2 + width / 2 + componentDistance,
                    max: params.add_right_front_lean_porch ? params.leanF_p_pos + params.leanF_p_d / 2 + params.leanR_p_w - width / 2 - componentDistance : params.leanF_p_pos + params.leanF_p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'B_L_F_W' || wallName === 'B_L_L_S_W') {
                const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                if (height <= params.leanB_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_d / 2 + 0.15 + width / 2 + componentDistance,
                        max: params.p_d / 2 + 0.15 + params.leanB_p_w - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(backLeanAlpha);
                    return {
                        min: params.p_d / 2 + 0.15 + width / 2 + componentDistance,
                        max: params.p_d / 2 + 0.15 + minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'B_L_B_W') {
                const maxHeight = params.leanB_p_h + (params.b_l_t_r_pB / 12) * params.leanB_p_w + regularHeight - trimHeight;
                if (height <= params.leanB_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_d / 2 - 0.15 - params.leanB_p_w + width / 2 + componentDistance,
                        max: -params.p_d / 2 - 0.15 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(backLeanAlpha);
                    return {
                        min: -params.p_d / 2 - 0.15 - minValue + width / 2 + componentDistance,
                        max: -params.p_d / 2 - 0.15 - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'B_L_S_W') {
                return {
                    min: params.add_right_back_lean_porch ? -params.leanB_p_pos - params.leanB_p_d / 2 - params.leanR_p_w + width / 2 + componentDistance : -params.leanB_p_pos - params.leanB_p_d / 2 + width / 2 + componentDistance,
                    max: params.add_left_back_lean_porch ? -params.leanB_p_pos + params.leanB_p_d / 2 + params.lean_p_w - width / 2 - componentDistance : -params.leanB_p_pos + params.leanB_p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'R_L_F_W' || wallName === 'R_L_F_S_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2 + width / 2 + componentDistance,
                        max: params.p_w / 2 + params.leanR_p_w - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                    return {
                        min: params.p_w / 2 + width / 2 + componentDistance,
                        max: params.p_w / 2 + minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'R_L_B_W') {
                const maxHeight = params.leanR_p_h + (params.b_l_t_r_pR / 12) * params.leanR_p_w + regularHeight - trimHeight;
                if (height <= params.leanR_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_w / 2 - params.leanR_p_w + width / 2 + componentDistance,
                        max: -params.p_w / 2 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(rightLeanAlpha);
                    return {
                        min: -params.p_w / 2 - minValue + width / 2 + componentDistance,
                        max: -params.p_w / 2 - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'R_L_R_W') {
                return {
                    min: params.add_right_front_lean_porch ? -params.leanR_p_pos - params.leanR_p_d / 2 - params.leanF_p_w + width / 2 + componentDistance : -params.leanR_p_pos - params.leanR_p_d / 2 + width / 2 + componentDistance,
                    max: params.add_right_back_lean_porch ? -params.leanR_p_pos + params.leanR_p_d / 2 + params.leanB_p_w - width / 2 - componentDistance : -params.leanR_p_pos + params.leanR_p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'L_L_F_W' || wallName === 'L_L_F_S_W') {
                const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                if (height <= params.lean_p_h + regularHeight - trimHeight) {
                    return {
                        min: -params.p_w / 2 - params.lean_p_w + width / 2 + componentDistance,
                        max: -params.p_w / 2 - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(leftLeanAlpha);
                    return {
                        min: -params.p_w / 2 - minValue + width / 2 + componentDistance,
                        max: -params.p_w / 2 - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'L_L_B_W') {
                const maxHeight = params.lean_p_h + (params.b_l_t_r_p / 12) * params.lean_p_w + regularHeight - trimHeight;
                if (height <= params.lean_p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2 + width / 2 + componentDistance,
                        max: params.p_w / 2 + params.lean_p_w - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(leftLeanAlpha);
                    return {
                        min: params.p_w / 2 + width / 2 + componentDistance,
                        max: params.p_w / 2 + minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'L_L_L_W') {
                return {
                    min: params.add_left_back_lean_porch ? params.lean_p_pos - params.lean_p_d / 2 - params.leanB_p_w + width / 2 + componentDistance : params.lean_p_pos - params.lean_p_d / 2 + width / 2 + componentDistance,
                    max: params.add_left_front_lean_porch ? params.lean_p_pos + params.lean_p_d / 2 + params.leanF_p_w - width / 2 - componentDistance : params.lean_p_pos + params.lean_p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'c_b_r_s_w') {
                return {
                    min: -(parseInt(params.p_u_t) - params.p_d / 2) + width / 2 + componentDistance,
                    max: params.p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'c_b_l_s_w') {
                return {
                    min: -(params.p_d / 2 - width / 2 - componentDistance),
                    max: parseInt(params.p_u_t) - params.p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'c_b_l_s_f_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: -(params.p_w / 2 - width / 2 - componentDistance),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - width / 2 - componentDistance
                    }
                } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: -(minValue - width / 2 - componentDistance),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: -(minValue - width / 2 - componentDistance),
                        max: minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_left) + width / 2 + componentDistance,
                        max: params.p_w / 2 - width / 2 - componentDistance
                    }
                } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_left) - params.p_w / 2)) {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_left) + width / 2 + componentDistance,
                        max: minValue - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: -(minValue - width / 2 - componentDistance),
                        max: minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_right) + width / 2 + componentDistance,
                        max: params.p_w / 2 - width / 2 - componentDistance
                    }
                } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: params.p_w / 2 - parseInt(params.cB_addStorage_right) + width / 2 + componentDistance,
                        max: minValue - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: -(minValue - width / 2 - componentDistance),
                        max: minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                const maxHeight = params.p_h + (params.p_r_p / 12) * params.p_w / 2 + regularHeight - trimHeight ;
                if (height <= params.p_h + regularHeight - trimHeight) {
                    return {
                        min: -(params.p_w / 2 - width / 2 - componentDistance),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_right) - width / 2 - componentDistance
                    }
                } else if (height <= maxHeight - Math.tan(alpha) * (parseInt(params.cB_addStorage_right) - params.p_w / 2)) {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: -(minValue - width / 2 - componentDistance),
                        max: -params.p_w / 2 + parseInt(params.cB_addStorage_right) - width / 2 - componentDistance
                    }
                } else {
                    const minValue = (maxHeight - height) / Math.tan(alpha);
                    return {
                        min: -(minValue - width / 2 - componentDistance),
                        max: minValue - width / 2 - componentDistance
                    }
                }
            } else if (wallName === 'F_L_F_S_W') {
                return {
                    min: params.leanF_p_pos - params.leanF_p_d / 2 + width / 2 + componentDistance,
                    max: params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) - width / 2 - componentDistance
                }
            } else if (wallName === 'B_L_F_S_W') {
                return {
                    min: -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back) + width / 2 + componentDistance,
                    max: -params.leanB_p_pos + params.leanB_p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'R_L_R_S_W') {
                return {
                    min: -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right) + width / 2 + componentDistance,
                    max: -params.leanR_p_pos + params.leanR_p_d / 2 - width / 2 - componentDistance
                }
            } else if (wallName === 'R_L_L_S_W') {
                return {
                    min: params.leanR_p_pos - params.leanR_p_d / 2 + width / 2 + componentDistance,
                    max: params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) - width / 2 - componentDistance
                } 
            } else if (wallName === 'L_L_L_S_W') {
                return {
                    min: params.lean_p_pos - params.lean_p_d / 2 + width / 2 + componentDistance,
                    max: params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) - width / 2 - componentDistance
                } 
            } else if (wallName === 'L_L_R_S_W') {
                return {
                    min: -params.lean_p_pos + params.lean_p_d / 2 - parseInt(params.add_storage) + width / 2 + componentDistance,
                    max: -params.lean_p_pos + params.lean_p_d / 2 - width / 2 - componentDistance
                } 
            }
        }
    
    }, [positionY, wallName, height, width, params.singleSlope, params.p_w, params.p_d, params.p_h, params.p_r_s, params.leanF_p_h, params.leanF_p_w, params.leanF_p_d, params.leanF_p_pos, params.b_l_t_r_pF, params.leanB_p_h, params.leanB_p_w, params.leanB_p_d, params.leanB_p_pos, params.b_l_t_r_pB, params.leanR_p_h, params.leanR_p_w, params.leanR_p_d, params.leanR_p_pos, params.b_l_t_r_pR, params.lean_p_h, params.lean_p_w, params.lean_p_d, params.lean_p_pos, params.b_l_t_r_p, params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.add_right_back_lean_porch, params.add_left_back_lean_porch, params.p_u_t, params.cB_addStorage_left, params.cB_addStorage_right, params.add_storage_front, params.add_storage_back, params.add_storage_right, params.add_storage])

    const positionZ = useMemo(() => {
        //front, back wall
        if(wallName === 'c_b_f_w' || wallName === 'c_b_b_w' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_f_w' || wallName === 'c_b_r_s_b_w') {
            return (params.p_d / 2) - 0.1 ;
        //left, right wall
        } else if (wallName === 'c_b_l_w' || wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_l_s_w') {
            return params.p_w / 2 - 0.25;
        //center building storage
        } else if (wallName === 'c_b_f_s_w') {
            return parseInt(params.p_u_t) - params.p_d / 2 - 0.25 + backStorageoffset + backStoragePositionZ 
        } else if (wallName === 'c_b_l_s_r_w') {
            return -params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.25
        } else if (wallName === 'c_b_r_s_l_w') {
            return -params.p_w / 2 + parseInt(params.cB_addStorage_right) - 0.25
        //front lean    
        } else if (wallName === 'F_L_R_W') {
            // if (Number(params.leantoAlignmentFront) === 1) {
            //     return params.leanF_p_d / 2 - 0.25;
            // } else if (Number(params.leantoAlignmentFront) === 2) {
            //     return params.leanF_p_d - params.p_w / 2 - 0.25;
            // } else {
            //     return params.p_w / 2 - 0.25;
            // }
            return params.leanF_p_pos + params.leanF_p_d / 2 - 0.25;
        } else if (wallName === 'F_L_L_W') {
            // if (Number(params.leantoAlignmentFront) === 1) {
            //     return params.leanF_p_d / 2 - 0.25;
            // } else if (Number(params.leantoAlignmentFront) === 2) {
            //     return params.p_w / 2 - 0.25;
            // } else {
            //     return params.leanF_p_d - params.p_w / 2 - 0.25;
            // }
            return -params.leanF_p_pos + params.leanF_p_d / 2 - 0.25;
        } else if (wallName === 'F_L_F_W' || wallName === 'F_L_F_S_W') {
            return params.p_d / 2 + params.leanF_p_w - 0.1;
        //back lean
        } else if (wallName === 'B_L_F_W') {
            // if (Number(params.leantoAlignmentBack) === 1) {
            //     return params.leanB_p_d / 2 - 0.25;
            // } else if (Number(params.leantoAlignmentBack) === 2) {
            //     return params.p_w / 2 - 0.25;
            // } else {
            //     return params.leanB_p_d - params.p_w / 2 - 0.25;
            // }
            return params.leanB_p_pos + params.leanB_p_d / 2 - 0.25
        } else if (wallName === 'B_L_B_W') {
            // if (Number(params.leantoAlignmentBack) === 1) {
            //     return params.leanB_p_d / 2 - 0.25;
            // } else if (Number(params.leantoAlignmentBack) === 2) {
            //     return params.leanB_p_d - params.p_w / 2 - 0.25;
            // } else {
            //     return params.p_w / 2 - 0.25;
            // }
            return -params.leanB_p_pos + params.leanB_p_d / 2 - 0.25
        } else if (wallName === 'B_L_S_W' || wallName === 'B_L_F_S_W') {
            return params.p_d / 2 + params.leanB_p_w - 0.1;
        //left lean
        } else if (wallName === 'L_L_F_W') {
            // if (Number(params.leantoAlignmentLeft) === 1) {
            //     return params.lean_p_d / 2;
            // } else if (Number(params.leantoAlignmentLeft) === 2) {
            //     return params.p_d / 2;
            // } else {
            //     return params.lean_p_d - params.p_d / 2;
            // }
            return params.lean_p_pos + params.lean_p_d / 2 - 0.1
        } else if (wallName === 'L_L_B_W') {
            // if (Number(params.leantoAlignmentLeft) === 1) {
            //     return params.lean_p_d / 2;
            // } else if (Number(params.leantoAlignmentLeft) === 2) {
            //     return params.lean_p_d - params.p_d / 2;
            // } else {
            //     return params.p_d / 2;
            // }
            return -params.lean_p_pos + params.lean_p_d / 2 - 0.1
        } else if (wallName === 'L_L_L_W' || wallName === 'L_L_L_S_W') {
            return params.p_w / 2 + params.lean_p_w - 0.25
        //right lean
        } else if (wallName === 'R_L_F_W') {
            // if (Number(params.leantoAlignmentRight) === 1) {
            //     return params.leanR_p_d / 2;
            // } else if (Number(params.leantoAlignmentRight) === 2) {
            //     return params.p_d / 2;
            // } else {
            //     return params.leanR_p_d - params.p_d / 2;
            // }
            return params.leanR_p_pos + params.leanR_p_d / 2 - 0.1;
        } else if (wallName === 'R_L_B_W') {
            // if (Number(params.leantoAlignmentRight) === 1) {
            //     return params.leanR_p_d / 2;
            // } else if (Number(params.leantoAlignmentRight) === 2) {
            //     return params.leanR_p_d - params.p_d / 2;
            // } else {
            //     return params.p_d / 2;
            // }
            return -params.leanR_p_pos + params.leanR_p_d / 2 - 0.1;
        } else if (wallName === 'R_L_R_W' || wallName === 'R_L_R_S_W') {
            return params.p_w / 2 + params.leanR_p_w - 0.25
        } else if (wallName === 'F_L_R_S_W') {
            // if (Number(params.leantoAlignmentFront) === 1) {
            //     return -params.leanF_p_d / 2 + parseInt(params.add_storage_front) - 0.25;
            // } else if (Number(params.leantoAlignmentFront) === 2) {
            //     return -params.p_w / 2 + parseInt(params.add_storage_front) - 0.25;
            // } else {
            //     return -params.leanF_p_d + params.p_w / 2 + parseInt(params.add_storage_front) - 0.25;
            // }
            return params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) - 0.25 + frontLeanStorageoffset + frontLeanStoragePositionX
        } else if (wallName === 'B_L_L_S_W') {
            // if (Number(params.leantoAlignmentBack) === 1) {
            //     return -params.leanB_p_d / 2 + parseInt(params.add_storage_back) - 0.25;
            // } else if (Number(params.leantoAlignmentBack) === 2) {
            //     return -params.leanB_p_d + params.p_w / 2 + parseInt(params.add_storage_back) - 0.25;
            // } else {
            //     return -params.p_w / 2 + parseInt(params.add_storage_back) - 0.25;
            // }
            return params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back) - 0.25 + backLeanStorageoffset + backLeanStoragePositionX
        } else if (wallName === 'R_L_F_S_W') {
            // if (Number(params.leantoAlignmentRight) === 1) {
            //     return -params.leanR_p_d / 2 + parseInt(params.add_storage_right) - 0.25;
            // } else if (Number(params.leantoAlignmentRight) === 2) {
            //     return -params.leanR_p_d + params.p_d / 2 + parseInt(params.add_storage_right) - 0.25;
            // } else {
            //     return -params.p_d / 2 + parseInt(params.add_storage_right) - 0.25;
            // }
            return params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) - 0.25 + rightLeanStorageoffset + rightLeanStoragePositionZ;
        } else if (wallName === 'R_L_L_S_W') {
            return -params.p_w / 2 - 0.25;
        } else if (wallName === 'L_L_F_S_W') {
            // if (Number(params.leantoAlignmentLeft) === 1) {
            //     return -params.lean_p_d / 2 + parseInt(params.add_storage) - 0.25;
            // } else if (Number(params.leantoAlignmentLeft) === 2) {
            //     return -params.lean_p_d + params.p_d / 2 + parseInt(params.add_storage) - 0.25;
            // } else {
            //     return -params.p_d / 2 + parseInt(params.add_storage) - 0.25;
            // }
            return params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) - 0.25 + leftLeanStorageoffset + leftLeanStoragePositionZ
        } else if (wallName === 'L_L_R_S_W') {
            return -params.p_w / 2 - 0.25;
        }
    
    }, [wallName, params.p_w, params.p_d, params.leanF_p_w, params.leanF_p_d, params.leanF_p_pos, params.leanB_p_w, params.leanB_p_d, params.leanB_p_pos, params.leanR_p_w, params.leanR_p_d, params.leanR_p_pos, params.lean_p_w, params.lean_p_d, params.lean_p_pos, params.p_u_t, params.cB_addStorage_left, params.cB_addStorage_right, params.add_storage_front, params.add_storage_back, params.add_storage_right, params.add_storage, backStoragePositionZ, leftLeanStoragePositionZ, rightLeanStoragePositionZ, frontLeanStoragePositionX, backLeanStoragePositionX /*, params.leantoAlignmentFront, params.leantoAlignmentRight, params.leantoAlignmentLeft, params.leantoAlignmentBack */]);

    const rotationY = useMemo(() => {
        if(wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W') {
            setPlane(new THREE.Plane(new THREE.Vector3(0, 0, 1), isDrag ? -(positionZ + 0.3) : -positionZ));
            return 0;
        } else if (wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W') {
            setPlane(new THREE.Plane(new THREE.Vector3(0, 0, -1), isDrag ? -(positionZ + 0.3) : -positionZ));
            return Math.PI;
        } else if (wallName === 'c_b_r_w' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'R_L_R_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W') {
            setPlane(new THREE.Plane(new THREE.Vector3(1, 0, 0), isDrag ? -(positionZ + 0.3) : -positionZ));
            return Math.PI / 2;
        } else if (wallName === 'c_b_l_w' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'L_L_L_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W') {
            setPlane(new THREE.Plane(new THREE.Vector3(-1, 0, 0), isDrag ? -(positionZ + 0.3) : -positionZ));
            return -Math.PI / 2;
        }
    }, [wallName]);
    
    // const bind = useDrag(
    //     ({ down, delta, first, event }) => {
    //         event.ray.intersectPlane(plane, intersect);
    //         let [newX, newY, newZ] = intersect.toArray();

    //         let isDraggable = false;
    //         let isDoorTransparent = checkDoorTransparent();

    //         if ((const_var.controls !== undefined) && (((controls.isCheckActiveTab === 'doorwindow' || params.is_translusant) ? (!isDoorTransparent) : true))) {
    //             const currentAzimuthalAngle = (const_var.controls!=undefined && const_var.controls != '') ? const_var.controls.getAzimuthalAngle() : 0 ;
    //             if (currentAzimuthalAngle === 0) {
    //                 if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W') {
    //                     isDraggable = true;
    //                 }
    //             } else if (currentAzimuthalAngle > 0 && currentAzimuthalAngle < Math.PI / 2) {
    //                 if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' ||
    //                     wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W'
    //                 ) {
    //                     isDraggable = true;
    //                 }
    //             } else if (currentAzimuthalAngle === Math.PI / 2) {
    //                 if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W') {
    //                     isDraggable = true;
    //                 }
    //             } else if (currentAzimuthalAngle > Math.PI / 2 && currentAzimuthalAngle < Math.PI) {
    //                 if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W' ||
    //                     wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W'
    //                 ) {
    //                     isDraggable = true;
    //                 }
    //             } else if (currentAzimuthalAngle === Math.PI) {
    //                 if (wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W') {
    //                     isDraggable = true;
    //                 }
    //             } else if (currentAzimuthalAngle < 0 && currentAzimuthalAngle > -Math.PI / 2) {
    //                 if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' ||
    //                     wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W'
    //                 ) {
    //                     isDraggable = true;
    //                 }
    //             } else if (currentAzimuthalAngle === -Math.PI / 2) {
    //                 if (wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W') {
    //                     isDraggable = true;
    //                 }
    //             } else if (currentAzimuthalAngle < -Math.PI / 2 && -Math.PI / 2 > -Math.PI) {
    //                 if (wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W' ||
    //                     wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W'
    //                 ) {
    //                     isDraggable = true;
    //                 }
    //             }
    //         }

    //         if (isDraggable ) {
    //             event.stopPropagation();
    //             const_var.doorUniqueId = id
    //             setIsDrag(down);

    //             if (first) {
    //                 if (rotationY === 0) newX = positionX;                    // cmp position is front
    //                 else if (rotationY === Math.PI) newX = -positionX;        // cmp position is back
    //                 else if (rotationY === Math.PI / 2) newZ = -positionX;    // cmp position is right
    //                 else if (rotationY === -Math.PI / 2) newZ = positionX;    // cmp position is left
    //                 setStartPositionXY({ x: positionX, y: positionY });
    //             }

    //             if (down === true) {
    //                 const_var.controls.enableRotate = false;
    //                 const_var.componentsMoving = true;
    //                 get().gl.domElement.style.cursor = 'move';

    //                 setBindDelta(delta);
                    
    //                 /* x - limit*/

    //                 let adjustedX;
    //                 if (rotationY === 0) {
    //                     adjustedX = newX;
    //                 } else if (rotationY === Math.PI) {
    //                     adjustedX = -newX;
    //                 } else if (rotationY === Math.PI / 2) {
    //                     adjustedX = -newZ;
    //                 } else if (rotationY === -Math.PI / 2) {
    //                     adjustedX = newZ;
    //                 }

    //                 if (adjustedX < limitX.min) {
    //                     setPositionX(limitX.min);
    //                 } else if (adjustedX > limitX.max) {
    //                     setPositionX(limitX.max);
    //                 } else {
    //                     setPositionX(adjustedX);
    //                 }
    //                 /* x - limit*/
    //             } else {
    //                 const_var.controls.enableRotate = true;
    //                 get().gl.domElement.style.cursor = 'auto'

    //                 let isFind = false;
    //                 let isSetPosition = false;
    //                 const doorsArray = [...const_var.newDoorsArray];
    //                 const overlapDoorArrTemp = Overlap(sideArray, id, width, height, positionX, positionY, componentDistance, wallName);
    //                 if (overlapDoorArrTemp.length > 0) isFind = true;

    //                 revertPosOfCmp(doorsArray, wallName)

    //                 if((positionX < limitX.min || positionX > limitX.max)) {
    //                     isSetPosition = false;
    //                 } else {
    //                     isSetPosition = true;
    //                 }

    //                 revertPosOfCmp(doorsArray, wallName)
                    
    //                 if (isFind || !isSetPosition) {
    //                     setPositionX(startPositionXY.x);
    //                     setPositionY(startPositionXY.y);
    //                 } else {
    //                     setStartPositionXY({ x: positionX, y: positionY });
    //                     dispatch(actionCreator.updateDoorWindowPosition(id, positionX, positionY));
    //                     dispatch(actionCreator.updateDoorWindowLimitPosition(id, limitX.min, limitX.max));
    //                 }
    //             }
    //         }
    //         removeFocus()
    //     },
    //     { pointerEvents: true }
    // );

    const onClickDoorComponent = (e) => {
        setCanClone(true)
        setIsDelBtnClicked(false);

        let isSelect = false;
        
        // if ((const_var.controls !== undefined) && (((controls.isCheckActiveTab === 'doorwindow' || params.is_translusant) ? (!transparentState) : true))) {
        if (const_var.controls !== undefined) {
            const currentAzimuthalAngle = (const_var.controls!=undefined && const_var.controls != '') ? const_var.controls.getAzimuthalAngle() : 0 ;
            if (currentAzimuthalAngle === 0) {
                if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W') {
                    isSelect = true;
                }
            } else if (currentAzimuthalAngle > 0 && currentAzimuthalAngle < Math.PI / 2) {
                if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' ||
                    wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W'
                ) {
                    isSelect = true;
                }
            } else if (currentAzimuthalAngle === Math.PI / 2) {
                if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W') {
                    isSelect = true;
                }
            } else if (currentAzimuthalAngle > Math.PI / 2 && currentAzimuthalAngle < Math.PI) {
                if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W' ||
                    wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W'
                ) {
                    isSelect = true;
                }
            } else if (currentAzimuthalAngle === Math.PI) {
                if (wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W') {
                    isSelect = true;
                }
            } else if (currentAzimuthalAngle < 0 && currentAzimuthalAngle > -Math.PI / 2) {
                if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' ||
                    wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W'
                ) {
                    isSelect = true;
                }
            } else if (currentAzimuthalAngle === -Math.PI / 2) {
                if (wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W') {
                    isSelect = true;
                }
            } else if (currentAzimuthalAngle < -Math.PI / 2 && -Math.PI / 2 > -Math.PI) {
                if (wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W' ||
                    wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W'
                ) {
                    isSelect = true;
                }
            }
        }

        if (isSelect) {
            e.stopPropagation();
            dispatch(actionCreator.setSelectedCmpType('door'))
            dispatch(actionCreator.setIsShowEditIconSection(true));
            const_var.timer = setTimeout(() => {
                removeFocus()
            },10000)
        }
    }

    const removeFocus = () => {
        if(const_var.showComponentEditBox == false){
            if((document.getElementsByClassName("delete-tooltip") != undefined && document.getElementsByClassName("delete-tooltip")[0]) || (document.getElementsByClassName("warning-tooltip") != undefined && document.getElementsByClassName("warning-tooltip")[0])){
                
            }else{
                dispatch(actionCreator.setSelectedCmpType('none'))
                dispatch(actionCreator.setIsShowEditIconSection(false));
                clearTimeout(const_var.timer);
                setCanClone(true);
            }
            
        }
    }

    const handleDeleteClick = () => {
        if(isDelBtnClicked == true){
            setIsDelBtnClicked(false);
            dispatch(actionCreator.setSelectedCmpType('none'));
            dispatch(actionCreator.setIsShowEditIconSection(false));
            clearTimeout(const_var.timer);
        }
    }

    const handleSetCanClone = () => {
        setCanClone(true);
        dispatch(actionCreator.setSelectedCmpType('none'));
        dispatch(actionCreator.setIsShowEditIconSection(false));
        clearTimeout(const_var.timer);
    }

    const onClickEditButton = (e) => {
        dispatch(actionCreator.handleIconClick(e, id,'door'))
    }
    
    const cloneComponent = (doorUniqueId, e) => {
        const selectedDoor = const_var.newDoorsArray.filter((item) => item.uniqueId === doorUniqueId);
        const priceData = const_var.entry_points.filter((item) => item.uniqueId === doorUniqueId);

        // implement the clearance free space size
        let parentkey = '';
        let childkey = '';
        let nestedkey = '';
        
        if (selectedDoor.length > 0) {
            parentkey = selectedDoor[0].parent_array_key;
            childkey = selectedDoor[0].child_array_key;
            nestedkey = selectedDoor[0].nested_array_key;
        }
        
        const validationVariable = addValidation({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey });
        const isAdd = validationVariable.isAdd;
        setCanClone(isAdd);

        // setTimeout(() => {
        //     setCanClone(true);
        // }, 3000);

        if(isAdd){
            setIsCloned(!isCloned);
            setTimeout(() => {
                setIsCloned(false)
            }, 3000);

            if (selectedDoor.length > 0 && priceData.length > 0) {
                let targetObj = {...priceData[0]};
                targetObj.component_wall_name = selectedDoor[0].userData.wallName
                
                dispatch(actionCreator.cloneComponent(doorUniqueId, targetObj))
                dispatch(actionCreator.handleCloseforDoorWindows(e));
            }

            // if (selectedDoor.length > 0) {
            //     const compType = selectedDoor[0].userData.compType;
            //     const compName = selectedDoor[0].userData.compName;
            //     const wallName = selectedDoor[0].userData.wallName;
            //     const size = selectedDoor[0].size;
            //     const parentkey = selectedDoor[0].parent_array_key;
            //     const childkey = selectedDoor[0].child_array_key;
            //     const nestedkey = selectedDoor[0].nested_array_key;
            //     const is_edit = selectedDoor[0].is_edit;
            //     const parentOBJ = selectedDoor[0].parentOBJ;
            //     const isBreezewayFrame = selectedDoor[0].isBreezewayFrame;
            //     const breezewayUniqueI = selectedDoor[0].breezewayUniqueI;
                
            //     loadDoorComponentOnWall(compType, compName, wallName, size, parentkey, childkey, nestedkey, '', '', is_edit, parentOBJ, isBreezewayFrame, breezewayUniqueI);
            //     handleCloseforDoorWindows(e)
            // }
        } else{
            setIsCloned(false);
        }
    }

    const addedDoorPos = useMemo(() => {
        if (isCloned) {
            const addedDoorInfo = const_var.newDoorsArray.find(s => s.uniqueId === const_var.doorUniqueId)
            
            return [addedDoorInfo.positionX - positionX - width, height / 1.2, 1]
        }
    }, [isCloned])     

    const occludeState = useMemo(() => {
        let res = false;
        if (const_var.doorUniqueId === id) {
            const direction = getWallDirOnCanvas(wallName);
            if (currentAzimuthalAngle >= -(Math.PI / 2 - camAngle) && currentAzimuthalAngle < (Math.PI / 2 - camAngle)) {
                res = (direction !== 'front');
            } else if (currentAzimuthalAngle >= (Math.PI / 2 - camAngle) && currentAzimuthalAngle < (Math.PI / 2 - camAngle + camAngle * 2)) {
                res = (direction !== 'right');
            } else if (currentAzimuthalAngle >= -((Math.PI / 2 - camAngle) + camAngle * 2) && currentAzimuthalAngle < -(Math.PI / 2 - camAngle)) {
                res = (direction !== 'left');
            } else {
                res = (direction !== 'back');
            }
        }

        return res;
    }, [currentAzimuthalAngle, camAngle, wallName, const_var.doorUniqueId, id]);

    const handleMouseEvent = (e) => {
        if (const_var.callMesure) {
            switch (e.type) {
                case 'pointerover':
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);
    
    // const handleCloseforDoorWindows = (e) => {
    //     setIsDelBtnClicked(false)
    //     dispatch(actionCreator.handleCloseforDoorWindows(e));
    // }

    useOutsideClick(editRef, (e) => {
        if (!(const_var.showComponentEditBox || const_var.isShowAlert)) setIsDelBtnClicked(false)
        if (const_var.showComponentEditBox || const_var.isShowAlert || !!e.target.innerText) return
        if (const_var.doorUniqueId === id) {
            dispatch(actionCreator.setSelectedCmpType('none'))
            dispatch(actionCreator.setIsShowEditIconSection(false))
        };
    }, [isDelBtnClicked]);

    /**********Delete doors and windows when change the wall state********* */
    useMemo(() => {
        if (!isDrag) {
            if (wallName === 'c_b_f_w') {
                if (params.p_f_w !== 'Close') {
                    if (params.cB_addStorage_check_left) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= -params.p_w / 2 + params.cB_addStorage_left) {
                                newArray[currentIndex].userData.wallName = 'c_b_l_s_f_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else if (params.cB_addStorage_check_right) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= params.p_w / 2 - params.cB_addStorage_right) {
                                newArray[currentIndex].userData.wallName = 'c_b_r_s_f_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                     } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'c_b_b_w') {
                if (params.p_b_w !== 'Close') {
                    if (params.cB_addStorage_check_left) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= params.p_w / 2 - params.cB_addStorage_left) {
                                newArray[currentIndex].userData.wallName = 'c_b_l_s_b_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else if (params.cB_addStorage_check_right) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= -params.p_w / 2 + params.cB_addStorage_right) {
                                newArray[currentIndex].userData.wallName = 'c_b_r_s_b_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                     } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'c_b_r_w') {
                if (params.p_r_w !== 'Close' && compType !== 'garage_door_frameout' && compType !== 'walkin_frameout') {
                    if (params.p_u_c) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= params.p_d / 2 - params.p_u_t) {
                                newArray[currentIndex].userData.wallName = 'c_b_r_s_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'c_b_l_w') {
                if (params.p_l_w !== 'Close' && compType !== 'garage_door_frameout' && compType !== 'walkin_frameout') {
                    if (params.p_u_c) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= -params.p_d / 2 + params.p_u_t) {
                                newArray[currentIndex].userData.wallName = 'c_b_l_s_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'c_b_f_s_w') {
                if (params.p_u_c === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_r_s_w') {
                if (params.p_u_c === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.p_u_c === true && params.p_r_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_r_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_l_s_w') {
                if (params.p_u_c === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.p_u_c === true && params.p_l_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_l_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_l_s_r_w') {
                if (params.cB_addStorage_check_left === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_l_s_f_w') {
                if (params.cB_addStorage_check_left === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.cB_addStorage_check_left === true && params.p_f_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_f_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                if (params.cB_addStorage_check_left === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.cB_addStorage_check_left === true && params.p_b_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_b_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_r_s_l_w') {
                if (params.cB_addStorage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                if (params.cB_addStorage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.cB_addStorage_check_right === true && params.p_f_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_f_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                if (params.cB_addStorage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.cB_addStorage_check_right === true && params.p_b_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_b_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'F_L_R_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'F_L_L_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'F_L_F_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_l !== 'Close' && compType !== 'garage_door_frameout' && compType !== 'walkin_frameout')) {
                    if (params.add_storage_check_front) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front)) {
                                newArray[currentIndex].userData.wallName = 'F_L_F_S_W';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'F_L_R_S_W') {
                if (params.add_storage_check_front === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'F_L_F_S_W') {
                if (params.add_storage_check_front === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_front === true && params.p_b_c_b_f_l === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'F_L_F_W';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'B_L_F_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'B_L_B_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'B_L_S_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_l !== 'Close' && compType !== 'garage_door_frameout' && compType !== 'walkin_frameout')) {
                    if (params.add_storage_check_back) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back)) {
                                newArray[currentIndex].userData.wallName = 'B_L_F_S_W';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'B_L_L_S_W') {
                if (params.add_storage_check_back === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'B_L_F_S_W') {
                if (params.add_storage_check_back === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_back === true && params.p_b_c_b_b_l === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'B_L_S_W';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_F_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_B_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_R_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r !== 'Close' && compType !== 'garage_door_frameout' && compType !== 'walkin_frameout')) {
                    if (params.add_storage_check_right) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right)) {
                                newArray[currentIndex].userData.wallName = 'R_L_R_S_W';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'R_L_F_S_W') {
                if (params.add_storage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_R_S_W') {
                if (params.add_storage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_right === true && params.p_b_c_b_r === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'R_L_R_W';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_L_S_W') {
                if (params.add_storage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_F_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_B_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_L_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l !== 'Close' && compType !== 'garage_door_frameout' && compType !== 'walkin_frameout')) {
                    if (params.add_storage_check) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage)) {
                                newArray[currentIndex].userData.wallName = 'L_L_L_S_W';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'L_L_F_S_W') {
                if (params.add_storage_check === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_L_S_W') {
                if (params.add_storage_check === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check === true && params.p_b_c_b_l === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'L_L_L_W';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_R_S_W') {
                if (params.add_storage_check === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            }
        }
    
    }, [wallName, params.p_f_w, params.p_b_w, params.p_r_w, params.p_l_w, params.p_u_c, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.add_front_lean, params.p_b_c_b_f_f, params.p_b_c_b_f_b, params.p_b_c_b_f_l, params.add_storage_check_front, params.add_back_lean, params.p_b_c_b_b_f, params.p_b_c_b_b_b, params.p_b_c_b_b_l, params.add_storage_check_back, params.add_right_lean, params.p_b_c_b_r_f, params.p_b_c_b_r_b, params.p_b_c_b_r, params.add_storage_check_right, params.add_left_lean, params.p_b_c_b_l_f, params.p_b_c_b_l_b, params.p_b_c_b_l, params.add_storage_check])

    useEffect(() => {
        // if(const_var.entry_points) {
            const currentComponent = const_var.entry_points.filter((item) => item.uniqueId == id);
            if (currentComponent.length > 0) {
                const clearance = const_var.newComponentArray[currentComponent[0].parent_array_key][currentComponent[0].child_array_key][currentComponent[0].nested_array_key]['Size'][`${width}x${height}`];
                const isEndSide = const_var.entry_wall_location[wallName];

                if (clearance) {
                    if (isEndSide.includes('end') && clearance.end_clearance) {
                        let maxHeight = Math.round(limitY.max) - clearance.end_clearance;

                        // let clearanceFromRoof = true;
                        if (params.m_s_n== 153) {
                            if (currentComponent[0].component_wall_name == "c_b_f_w" || currentComponent[0].component_wall_name == "c_b_b_w" || currentComponent[0].component_wall_name == "c_b_f_s_w") {
                                let doors = const_var.entry_points.filter((e) => {
                                  if ( e.component_wall_name == currentComponent[0].component_wall_name && 
                                    e.uniqueId != currentComponent[0].uniqueId &&
                                    e.entry_dimension_height >= params.p_h -1) {
                                    return true;
                                  }
                                });
                                if (doors.length > 0 || height > params.p_h - 1) {
                                    // clearanceFromRoof = false;
                                    maxHeight = params.p_h - clearance.end_clearance;
                                }
                            }
                        }


                        if (maxHeight < height) {
                            const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                            setIsAvailablePlace(false);
                            dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                        }
                    } else if (clearance.side_clearance) {
                        const maxHeight = Math.round(limitY.max) - clearance.side_clearance;
                        if (maxHeight < height) {
                            const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                            setIsAvailablePlace(false);
                            dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                        }
                    }
                }
            }
        // }

    }, [params.p_h, params.lean_p_h, params.leanR_p_h, params.leanF_p_h, params.leanB_p_h]);

    /**********Delete doors and windows when change the wall size********* */
    useMemo(() => {
        // if (!isLeanDragging && positionX === startPositionXY.x && positionY === startPositionXY.y &&
        //     (positionX < limitX.min || positionX > limitX.max || positionY + height / 2 > limitY.max)
        // () {

        if (!isDrag) {
            if (/* !isLeanDragging && defaultPositionX === startPositionXY.x && defaultPositionY === startPositionXY.y && */
                ((limitX != undefined && limitX.min != undefined && defaultPositionX < limitX.min) || (limitX != undefined && limitX.max != undefined && defaultPositionX > limitX.max) || (limitY != undefined && limitY.max != undefined && defaultPositionY + height / 2 > limitY.max))
            ) {
                const currentCompObj = const_var.newDoorsArray.find(item => item.uniqueId === id);
                const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                setIsAvailablePlace(false);
                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                
                if (const_var.isFromCompare) {
                    dispatch(actionCreator.addDoorComponent(compType, compName, wallName, currentCompObj.size, currentCompObj.parent_array_key, currentCompObj.child_array_key, currentCompObj.nested_array_key, currentCompObj))
                }
            } else {
                let isFind = false;
                const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(wallName));
                const doorsArray = [...const_var.newDoorsArray]
                revertPosOfCmp(doorsArray, wallName)

                doorsArray
                    .filter((item) => item.uniqueId !== id && targetWallNameArr.includes(item.userData.wallName))
                    .map((item) => {
                        if (Math.abs(item.positionX - defaultPositionX) < item.width / 2 + width / 2 + componentDistance && Math.abs(item.positionY - defaultPositionY) < item.height / 2 + height / 2 + componentDistance) {
                            isFind = true;
                        }
                })
                
                revertPosOfCmp(doorsArray, wallName)

                if (isFind && (wallName === 'L_L_L_W' || wallName === 'R_L_R_W' || wallName === 'F_L_F_W' || wallName === 'B_L_S_W')){
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            }
        }
        
    }, [limitX, limitY, defaultPositionX, defaultPositionY]);

    /**********Change door trim color and truss when overlap each other********* */
    // useEffect(() => {

    // if(isPattern){
    //     const buildingType = wallnameBySec[wallName];
    //     const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(wallName));
    //     const sideArray = [...const_var.newDoorsArray.filter((item) => item.uniqueId !== id && targetWallNameArr.includes(item.userData.wallName))];

    //     if (isDrag) {
    //         const overlapDoorArrTemp = Overlap(sideArray, id, width, height, positionX, positionY, componentDistance, wallName);
    //         let overlapTrussArrTemp = [];

    //         if (buildingType === 'center') {
    //             overlapTrussArrTemp = TrussOverlap(mainTrussPosInfo, wallName, positionX, width, buildingType);
    //         } else if(buildingType !== 'center' && (wallName === 'L_L_L_W' || wallName === 'R_L_R_W' || wallName === 'F_L_F_W' || wallName === 'B_L_S_W')) {
    //             overlapTrussArrTemp = TrussOverlap(leanToTrussPosInfo, wallName, positionX, width, buildingType)
    //         }
    //         if (JSON.stringify(overlapDoorArrTemp) !== JSON.stringify(overlapDoorArr)) {
    //             setOverlapDoorArr(overlapDoorArrTemp);
    //         }
    //         if (JSON.stringify(overlapTrussArr) !== JSON.stringify(overlapTrussArrTemp)) {
    //             setOverlapTrussArr(overlapTrussArrTemp);
    //         }
    //     } else {
    //         setOverlapDoorArr([]);
    //         setOverlapTrussArr([]);

    //         if(positionX !== startPositionXY.x){
    //             setPositionX(startPositionXY.x)
    //         } else {
    //             setPositionX(positionX)
    //         }
    //         if(positionY !== startPositionXY.y){
    //             setPositionY(startPositionXY.y)
    //         } else {
    //             setPositionY(positionY)
    //         }
    //     }
    // }
    
    // }, [positionX, positionY, isDrag, mainTrussPosInfo, leanToTrussPosInfo, startPositionXY])

    /**********Change door opacity depending on the section in focus********* */
    // useEffect(() => {
    //     if (controls.isCheckActiveTab === 'doorwindow') {
    //         if (const_var.focusedSection === 'center') {
    //             if (
    //                 (wallName === 'c_b_f_w' && params.activeWall != "c_b_f_s_w") || 
    //                 wallName === 'c_b_b_w' || 
    //                 (wallName === 'c_b_r_w' && params.activeWall != "c_b_l_s_r_w")|| 
    //                 (wallName === 'c_b_l_w' && params.activeWall != "c_b_r_s_l_w")|| 
    //                 wallName === 'c_b_f_s_w' || 
    //                 wallName === 'c_b_r_s_w' || 
    //                 wallName === 'c_b_l_s_w' || 
    //                 wallName === 'c_b_l_s_r_w' || 
    //                 wallName === 'c_b_l_s_f_w' || 
    //                 wallName === 'c_b_l_s_b_w' || 
    //                 wallName === 'c_b_r_s_l_w' || 
    //                 wallName === 'c_b_r_s_f_w' || 
    //                 wallName === 'c_b_r_s_b_w'
    //             ) {
    //                 setOpacityValue(1);
    //                 setTransparentState(false)
    //             } else {
    //                 setOpacityValue(0.02);
    //                 setTransparentState(true)
    //             }
    //         } else if (const_var.focusedSection === 'frontlean') {
    //             if (
    //                 (wallName === 'F_L_R_W' && params.activeWall != "F_L_R_S_W")|| 
    //                 wallName === 'F_L_L_W' || 
    //                 wallName === 'F_L_F_W' || 
    //                 wallName === 'F_L_R_S_W' || 
    //                 wallName === 'F_L_F_S_W'
    //             ) {
    //                 setOpacityValue(1);
    //                 setTransparentState(false)
    //             } else {
    //                 setOpacityValue(0.02);
    //                 setTransparentState(true)
    //             }
    //         } else if (const_var.focusedSection === 'backlean') {
    //             if (
    //                 (wallName === 'B_L_F_W' && params.activeWall != "B_L_L_S_W") || 
    //                 wallName === 'B_L_B_W' || 
    //                 wallName === 'B_L_S_W' || 
    //                 wallName === 'B_L_L_S_W' || 
    //                 wallName === 'B_L_F_S_W'
    //             ) {
    //                 setOpacityValue(1);
    //                 setTransparentState(false)
    //             } else {
    //                 setOpacityValue(0.02);
    //                 setTransparentState(true)
    //             }
    //         } else if (const_var.focusedSection === 'leftlean') {
    //             if (
    //                 (wallName === 'L_L_F_W' && params.activeWall != "L_L_F_S_W") || 
    //                 wallName === 'L_L_B_W' || 
    //                 wallName === 'L_L_L_W' || 
    //                 wallName === 'L_L_F_S_W' || 
    //                 wallName === 'L_L_L_S_W' ||
    //                 wallName === 'L_L_R_S_W'
    //             ) {
    //                 setOpacityValue(1);
    //                 setTransparentState(false)
    //             } else {
    //                 setOpacityValue(0.02);
    //                 setTransparentState(true)
    //             }
    //         } else if (const_var.focusedSection === 'rightlean') {
    //             if (
    //                 (wallName === 'R_L_F_W' && params.activeWall != "R_L_F_S_W") || 
    //                 wallName === 'R_L_B_W' || 
    //                 wallName === 'R_L_R_W' || 
    //                 wallName === 'R_L_F_S_W' || 
    //                 wallName === 'R_L_R_S_W' ||
    //                 wallName === 'R_L_L_S_W'
    //             ) {
    //                 setOpacityValue(1);
    //                 setTransparentState(false)
    //             } else {
    //                 setOpacityValue(0.02);
    //                 setTransparentState(true)
    //             }
    //         }
    //     } else {
    //         setOpacityValue(1);
    //         setTransparentState(false)
    //     }
    // }, [const_var.focusedSection, wallName, controls.isCheckActiveTab, params.activeWall === "R_L_F_S_W", params.activeWall === "L_L_F_S_W", params.activeWall === "B_L_L_S_W", params.activeWall === "F_L_R_S_W", params.activeWall === "c_b_f_s_w", params.activeWall === "c_b_l_s_r_w", params.activeWall === "c_b_r_s_l_w"]);

    useEffect(() => {
        if (selectedCmpType === 'door' && isShowEditIconSection && const_var.doorUniqueId === id) {
            if (editRef.current) editRef.current.parentElement.parentElement.style.zIndex = 1;
        }
    }, [isShowEditIconSection, const_var.isShowAlert, isotherDoorType, const_var.showComponentEditBox, editRef.current])

    useEffect(() => {
        setPositionX(defaultPositionX);
        setPositionY(defaultPositionY);
        setStartPositionXY({x: defaultPositionX, y: defaultPositionY});
    }, [defaultPositionX, defaultPositionY])

    const [delPosition, setDelPosition] = useState('right');
    const setDelTooltipPosition = (e) => {
        const tooltipSize = window.innerWidth > 992 ? [285, 211] : [215, 172];
        setDelPosition(getPosition(e, tooltipSize));
    }

    const [warnPosition, setWarnPosition] = useState('right');
    const setWarnTooltipPosition = (e) => {
        const tooltipSize = window.innerWidth > 992 ? [285, 74] : [215, 95];
        setWarnPosition(getPosition(e, tooltipSize));
    }

    useEffect(() => {
        if((wallName === 'c_b_r_w' && params.p_r_w === 'Open' && !params.p_c_p_l) || 
            (wallName === 'c_b_l_w' && params.p_l_w === 'Open' && !params.p_c_p_l) ||
            (wallName === 'F_L_F_W' && params.p_b_c_b_f_l === 'Open' && !params.p_c_p_l) ||
            (wallName === 'B_L_S_W' && params.p_b_c_b_b_l === 'Open' && !params.p_c_p_l) ||
            (wallName === 'R_L_R_W' && params.p_b_c_b_r === 'Open' && !params.p_c_p_l) ||
            (wallName === 'L_L_L_W' && params.p_b_c_b_l === 'Open' && !params.p_c_p_l) 
        ) {
            setTrimColor('#C8C8C8')
        } else {
            setTrimColor(params.p_t_c.replace('0x', '#'))
        }
    }, [wallName, params.p_r_w, params.p_l_w, params.p_b_c_b_f_l, params.p_b_c_b_b_l, params.p_b_c_b_r, params.p_b_c_b_l, params.p_t_c, params.p_c_p_l ])   

    useMemo(() => {
        const door = const_var.newDoorsArray.filter(item => item.uniqueId === id);
        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
        if (isAvailablePlace === false && door.length > 0) {
            dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
        }

    });

    const trussModelPosInfoArr = useMemo(() => {
        let count, distance = 0;
        
        const initDistance = legDistance;
        const tempCount = Math.floor(params.p_d / initDistance);
        if (params.p_d === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.p_d - tempCount * initDistance < initDistance / 2) {
            count = tempCount;
            distance = params.p_d / count;
        } else {
            count = tempCount + 1;
            distance = params.p_d / count;
        }
        
        const posInfoArr = Array.from({ length: count + 1 }, (_, index) => distance * index - params.p_d / 2)

        return posInfoArr
    }, [params.p_d, legDistance, params.trussType])

    const handleMouseDown = e => {
        let event = e
        let isDraggable = false;
        let isDoorTransparent = checkDoorTransparent();
        let currentComponent = e.eventObject

        if ((const_var.controls !== undefined) && (((controls.isCheckActiveTab === 'doorwindow' || params.is_translusant) ? (!isDoorTransparent) : true))) {
            const currentAzimuthalAngle = (const_var.controls!=undefined && const_var.controls != '') ? const_var.controls.getAzimuthalAngle() : 0 ;
            if (currentAzimuthalAngle === 0) {
                if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W') {
                    isDraggable = true;
                }
            } else if (currentAzimuthalAngle > 0 && currentAzimuthalAngle < Math.PI / 2) {
                if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' ||
                    wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W'
                ) {
                    isDraggable = true;
                }
            } else if (currentAzimuthalAngle === Math.PI / 2) {
                if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W') {
                    isDraggable = true;
                }
            } else if (currentAzimuthalAngle > Math.PI / 2 && currentAzimuthalAngle < Math.PI) {
                if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'F_L_R_W' || wallName === 'B_L_F_W' || wallName === 'c_b_l_s_r_w' || wallName === 'c_b_r_s_w' || wallName === 'F_L_R_S_W' || wallName === 'B_L_L_S_W' || wallName === 'R_L_R_S_W' || wallName === 'L_L_R_S_W' ||
                    wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W'
                ) {
                    isDraggable = true;
                }
            } else if (currentAzimuthalAngle === Math.PI) {
                if (wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W') {
                    isDraggable = true;
                }
            } else if (currentAzimuthalAngle < 0 && currentAzimuthalAngle > -Math.PI / 2) {
                if (wallName === 'c_b_f_w' || wallName === 'c_b_f_s_w' || wallName === 'F_L_F_W' || wallName === 'R_L_F_W' || wallName === 'L_L_F_W' || wallName === 'c_b_l_s_f_w' || wallName === 'c_b_r_s_f_w' || wallName === 'F_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_S_W' ||
                    wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W'
                ) {
                    isDraggable = true;
                }
            } else if (currentAzimuthalAngle === -Math.PI / 2) {
                if (wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W') {
                    isDraggable = true;
                }
            } else if (currentAzimuthalAngle < -Math.PI / 2 && -Math.PI / 2 > -Math.PI) {
                if (wallName === 'c_b_l_w' || wallName === 'L_L_L_W' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'c_b_l_s_w' || wallName === 'R_L_L_S_W' || wallName === 'L_L_L_S_W' ||
                    wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'R_L_B_W' || wallName === 'L_L_B_W' || wallName === 'c_b_l_s_b_w' || wallName === 'c_b_r_s_b_w' || wallName === 'B_L_F_S_W'
                ) {
                    isDraggable = true;
                }
            }
        }
          if(isDraggable && doorRef.current != undefined){
            const_var.controls.enableRotate = false;
            get().gl.domElement.style.cursor = 'move';
            const_var.controls.update();

            e.stopPropagation();
            const_var.doorUniqueId = id
            setIsDrag(true)
            // setCurrentComponent(e.eventObject)

            setStartPositionXY({ x: positionX, y: positionY });

            let intersectWall = scene.getObjectByName("intersectWall")
            let intersectLeg = scene.getObjectByName("intersectLeg")
            if(intersectWall != undefined){
                scene.remove(intersectWall)
                scene.remove(intersectLeg)
            }

            let adjustedX;
            let adjustedZ;
            if (rotationY === 0) {
                adjustedX = 0;
                adjustedZ = doorRef.current.position.z;
            } else if (rotationY === Math.PI) {
                adjustedX = 0;
                adjustedZ = -doorRef.current.position.z;
            } else if (rotationY === -Math.PI / 2) {
                adjustedX = -doorRef.current.position.z;
                adjustedZ = 0;
            } else if (rotationY === Math.PI / 2) {
                adjustedX = doorRef.current.position.z;
                adjustedZ = 0;
            }

            const model = new THREE.Shape();
            model.moveTo(limitX.min - width / 2 - componentDistance, 0 );
            model.lineTo(limitX.max + width / 2 + componentDistance, 0);
            model.lineTo(limitX.max + width / 2 + componentDistance, params.p_h+((params.p_r_p/12)*params.p_w));
            model.lineTo(limitX.min - width / 2 - componentDistance, params.p_h+((params.p_r_p/12)*params.p_w) );
            model.closePath();
            
            intersectWall = new THREE.Mesh(new THREE.ExtrudeGeometry(model, extrudeSettings(0.5)))
            intersectWall.position.set(adjustedX,0,adjustedZ)
            intersectWall.rotateY(rotationY)
            intersectWall.name = "intersectWall"
            intersectWall.visible = false
            scene.add(intersectWall)
            

            // Code start to highlight the legs which is intersecting the door
            if(doorRef.current.userData.section != undefined && 
                (
                    (doorRef.current.userData.section == "center" && (rotationY === -Math.PI / 2 || rotationY === Math.PI / 2)) || 
                    (doorRef.current.userData.section == "leftlean" && rotationY === -Math.PI / 2) ||
                    (doorRef.current.userData.section == "rightlean" && rotationY === Math.PI / 2) ||
                    (doorRef.current.userData.section == "frontlean" && rotationY === 0) ||
                    (doorRef.current.userData.section == "backlean" && rotationY === Math.PI)
                )
            ){

                let legPosArr = trussModelPosInfoArr.filter((leg)=>doorRef.current.position.x - (width/2) <= leg && doorRef.current.position.x + (width/2) >= leg)
                if(doorRef.current.userData.section !== "center" && const_var.leanToLegPosObj!=undefined){
                    let key = doorRef.current.userData.section.replace("lean", "");
                    legPosArr = const_var.leanToLegPosObj[key].filter((leg)=>doorRef.current.position.x - (width/2) <= leg && doorRef.current.position.x + (width/2) >= leg)
                }

                const legModel = new THREE.Shape();

                if(doorRef.current.userData.section == "center"){
                    legModel.moveTo(params.p_w / 2, 0 );
                    legModel.lineTo(params.p_w / 2, params.p_h);
                    if(params.singleSlope){
                        legModel.lineTo(-params.p_w / 2, params.p_h - ((params.p_r_p/12)*(params.p_w)));
                    }else{
                        legModel.lineTo(0, params.p_h + ((params.p_r_p/12)*(params.p_w/2)));
                        legModel.lineTo(-params.p_w / 2, params.p_h);
                    }
                    legModel.lineTo(-params.p_w / 2, 0 );
                    legModel.lineTo(-params.p_w / 2 + thickness, 0 );
                    if(params.singleSlope){
                        legModel.lineTo(-params.p_w / 2 + thickness, params.p_h - ((params.p_r_p/12)*(params.p_w)) - thickness);
                    }else{
                        legModel.lineTo(-params.p_w / 2 + thickness, params.p_h - thickness);
                        legModel.lineTo(0, params.p_h + ((params.p_r_p/12)*(params.p_w/2)) - thickness);
                    }
                    legModel.lineTo(params.p_w / 2 - thickness, params.p_h - thickness);
                    legModel.lineTo(params.p_w / 2 - thickness, 0 );
                }else if(doorRef.current.userData.section == "leftlean"){
                    legModel.moveTo(-params.p_w / 2 - params.lean_p_w, 0 );
                    legModel.lineTo(-params.p_w / 2 - params.lean_p_w, params.lean_p_h);
                    legModel.lineTo(-params.p_w / 2, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w)));
                    legModel.lineTo(-params.p_w / 2, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w)) - thickness);
                    legModel.lineTo(-params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h  - thickness);
                    legModel.moveTo(-params.p_w / 2 - params.lean_p_w + thickness, 0 );
                }else if(doorRef.current.userData.section == "rightlean"){
                    legModel.moveTo(params.p_w / 2 + params.leanR_p_w, 0 );
                    legModel.lineTo(params.p_w / 2 + params.leanR_p_w, params.leanR_p_h);
                    legModel.lineTo(params.p_w / 2, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)));
                    legModel.lineTo(params.p_w / 2, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - thickness);
                    legModel.lineTo(params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h  - thickness);
                    legModel.moveTo(params.p_w / 2 + params.leanR_p_w - thickness, 0 );
                }else if(doorRef.current.userData.section == "frontlean"){
                    legModel.moveTo(params.p_d / 2 + params.leanF_p_w, 0 );
                    legModel.lineTo(params.p_d / 2 + params.leanF_p_w, params.leanF_p_h);
                    legModel.lineTo(params.p_d / 2, params.leanF_p_h + ((params.b_l_t_r_pF/12)*(params.leanF_p_w)));
                    legModel.lineTo(params.p_d / 2, params.leanF_p_h + ((params.b_l_t_r_pF/12)*(params.leanF_p_w)) - thickness);
                    legModel.lineTo(params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h  - thickness);
                    legModel.moveTo(params.p_d / 2 + params.leanF_p_w - thickness, 0 );
                }else if(doorRef.current.userData.section == "backlean"){
                    legModel.moveTo(-params.p_d / 2 - params.leanB_p_w, 0 );
                    legModel.lineTo(-params.p_d / 2 - params.leanB_p_w, params.leanB_p_h);
                    legModel.lineTo(-params.p_d / 2, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w)));
                    legModel.lineTo(-params.p_d / 2, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w)) - thickness);
                    legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h  - thickness);
                    legModel.moveTo(-params.p_d / 2 - params.leanB_p_w + thickness, 0 );
                }
                legModel.closePath();

                intersectLeg = new THREE.Mesh(new THREE.ExtrudeGeometry(legModel, extrudeSettings(0.3)))
                intersectLeg.updateMatrix()
                intersectLeg.name = "intersectLeg"
                intersectLeg.visible = false
                intersectLeg.material.color.setHex("0x900000")
                intersectLeg.material.depthTest = false
                intersectLeg.material.transparent = false
                intersectLeg.material.needsUpdate = true
                scene.add(intersectLeg)


                legPosArr.map((legPos)=>{

                    let positionX = 0
                    let positionZ = legPos - (thickness/2)
                    if (doorRef.current.userData.section == "center" && rotationY === -Math.PI / 2){
                        positionZ = legPos - (thickness/2)
                    }else if(doorRef.current.userData.section == "center" && rotationY === Math.PI / 2){
                        positionZ = -legPos + (thickness/2)
                    }else if(doorRef.current.userData.section == "leftlean" && rotationY === -Math.PI / 2){
                        positionZ = legPos - (thickness/2)
                    }else if(doorRef.current.userData.section == "rightlean" && rotationY === Math.PI / 2){
                        positionZ = -legPos - (thickness/2)
                    }else if(doorRef.current.userData.section == "frontlean" && rotationY === 0){
                        positionZ = 0
                        positionX = legPos + (thickness/2)
                    }else if(doorRef.current.userData.section == "backlean" && rotationY === Math.PI){
                        positionZ = 0
                        positionX = -legPos + (thickness/2)
                    }

                    let currentLeg = legGroup.getObjectByName(`${legPos}`)
                    if(currentLeg == undefined){
                        let newLeg = intersectLeg.clone()
                        newLeg.visible = true
                        newLeg.name = `${legPos}`
                        newLeg.position.set(positionX,0,positionZ)
                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean") newLeg.rotation.y = -Math.PI / 2
                        newLeg.updateMatrix()
                        newLeg.material.color.setHex("0x900000")
                        newLeg.material.depthTest = false
                        newLeg.material.transparent = false
                        newLeg.material.needsUpdate = true
                        // newLeg.renderOrder = 2
                        legGroup.add(newLeg)
                    }else{
                        currentLeg.position.set(positionX,0,positionZ)
                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean") currentLeg.rotation.y = -Math.PI / 2
                        currentLeg.updateMatrix()
                        currentLeg.visible = true
                        currentLeg.material.transparent = false
                        currentLeg.material.needsUpdate = true
                        // currentLeg.renderOrder = 2
                    }

                })
            }
            // Code end to highlight the legs which is intersecting the door

        }

    

        const handleMouseMove = e => {
            
            if(doorRef.current != undefined && currentComponent != undefined && currentComponent.name == doorRef.current.name && isDraggable == true){
                
                let wall = scene.getObjectByName("intersectWall")
                let wallIntersect

                const rect = gl.domElement.getBoundingClientRect();
                const mouse = new THREE.Vector3();
                if(event.pointerType == "mouse"){
                    mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
                    mouse.y = 2 * -((e.clientY - rect.top) / rect.height) + 1;
                }else{
                    mouse.x = ((e.touches[0].clientX - rect.left) / rect.width) * 2 - 1;
                    mouse.y = 2 * -((e.touches[0].clientY - rect.top) / rect.height) + 1;
                }
            
                raycaster.setFromCamera(mouse, camera);
                if(wall != undefined) wallIntersect = raycaster.intersectObject(wall, true);
                let doorIntersect = raycaster.intersectObject(doorRef.current, true);

                if((wallIntersect != undefined && wallIntersect.length>0) || (doorIntersect != undefined && doorIntersect.length>0)){
                    const_var.componentsMoving = true;
                    
                    let intersetedObject
                    if(wallIntersect != undefined && wallIntersect.length>0){
                        intersetedObject = wallIntersect[0].point
                    } else if (doorIntersect != undefined && doorIntersect.length>0){
                        intersetedObject = doorIntersect[0].point
                    }
                    
                    if(intersetedObject != undefined){
                        let adjustedX;
                        if (rotationY === 0) {
                            adjustedX = intersetedObject.x;
                        } else if (rotationY === Math.PI) {
                            adjustedX = -intersetedObject.x;
                        } else if (rotationY === Math.PI / 2) {
                            adjustedX = -intersetedObject.z;
                        } else if (rotationY === -Math.PI / 2) {
                            adjustedX = intersetedObject.z;
                        }

                        if (adjustedX < limitX.min) {
                            // setPositionX(limitX.min);
                            doorRef.current.position.x = limitX.min
                        } else if (adjustedX > limitX.max) {
                            // setPositionX(limitX.max);
                            doorRef.current.position.x = limitX.max
                        } else {
                            // setPositionX(adjustedX);
                            doorRef.current.position.x = adjustedX
                        }

                        // Code start to highlight the legs which is intersecting the door
                        if(doorRef.current.userData.section != undefined && 
                            (
                                (doorRef.current.userData.section == "center" && (rotationY === -Math.PI / 2 || rotationY === Math.PI / 2)) || 
                                (doorRef.current.userData.section == "leftlean" && rotationY === -Math.PI / 2) ||
                                (doorRef.current.userData.section == "rightlean" && rotationY === Math.PI / 2) ||
                                (doorRef.current.userData.section == "frontlean" && rotationY === 0) ||
                                (doorRef.current.userData.section == "backlean" && rotationY === Math.PI)
                            )
                        ){
                            let legPosArr = trussModelPosInfoArr.filter((leg)=>doorRef.current.position.x - (width/2) <= leg && doorRef.current.position.x + (width/2) >= leg)
                            if(doorRef.current.userData.section !== "center" && const_var.leanToLegPosObj!=undefined){
                                let key = doorRef.current.userData.section.replace("lean", "");
                                legPosArr = const_var.leanToLegPosObj[key].filter((leg)=>doorRef.current.position.x - (width/2) <= leg && doorRef.current.position.x + (width/2) >= leg)
                            }
            
                            let intersectLeg = scene.getObjectByName("intersectLeg")

                            if(intersectLeg != undefined){
                                legPosArr.map((legPos)=>{
                                
                                    let positionX = 0
                                    let positionZ = legPos - (thickness/2)
                                    if (doorRef.current.userData.section == "center" && rotationY === -Math.PI / 2){
                                        positionZ = legPos - (thickness/2)
                                    }else if(doorRef.current.userData.section == "center" && rotationY === Math.PI / 2){
                                        positionZ = -legPos + (thickness/2)
                                    }else if(doorRef.current.userData.section == "leftlean" && rotationY === -Math.PI / 2){
                                        positionZ = legPos - (thickness/2)
                                    }else if(doorRef.current.userData.section == "rightlean" && rotationY === Math.PI / 2){
                                        positionZ = -legPos - (thickness/2)
                                    }else if(doorRef.current.userData.section == "frontlean" && rotationY === 0){
                                        positionZ = 0
                                        positionX = legPos + (thickness/2)
                                    }else if(doorRef.current.userData.section == "backlean" && rotationY === Math.PI){
                                        positionZ = 0
                                        positionX = -legPos + (thickness/2)
                                    }

                                    let currentLeg = legGroup.getObjectByName(`${legPos}`)
                                    if(currentLeg == undefined){
                                        let newLeg = intersectLeg.clone()
                                        newLeg.name = `${legPos}`
                                        newLeg.visible = true
                                        newLeg.position.set(positionX,0,positionZ)
                                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean") newLeg.rotation.y = -Math.PI / 2
                                        newLeg.updateMatrixWorld()
                                        newLeg.material.color.setHex("0x900000")
                                        newLeg.material.depthTest = false
                                        newLeg.material.transparent = false
                                        newLeg.material.needsUpdate = true
                                        // newLeg.renderOrder = 2
                                        legGroup.add(newLeg)
                                    }else{
                                        currentLeg.position.set(positionX,0,positionZ)
                                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean") currentLeg.rotation.y = -Math.PI / 2
                                        currentLeg.updateMatrixWorld()
                                        currentLeg.visible = true
                                        currentLeg.material.transparent = false
                                        currentLeg.material.needsUpdate = true
                                        // currentLeg.renderOrder = 2
                                    }
                                })
                                
                                legGroup.children.map((leg)=>{
                                    let currentLeg = legGroup.getObjectByName(`${leg.name}`)
                                    if(currentLeg != undefined){
                                        const isExist = legPosArr.indexOf(Number(currentLeg.name)) !== -1;
                                        if(!isExist){
                                            legGroup.remove(currentLeg)
                                        }
                                    }
                                })
                            }
                        }
                        // Code end to highlight the legs which is intersecting the door
                    }
                }
            }
        };
    
        
        const handleMouseUp = e => {
    
            legGroup.children = []
            const_var.controls.enableRotate = true;
            get().gl.domElement.style.cursor = 'auto'
            const_var.controls.update();
    
            if(isDraggable){
    
                setPositionX(doorRef.current.position.x)
                
                let isFind = false;
                let isSetPosition = false;
                const doorsArray = [...const_var.newDoorsArray];
                const overlapDoorArrTemp = Overlap(sideArray, id, width, height, doorRef.current.position.x, positionY, componentDistance, wallName);
                if (overlapDoorArrTemp.length > 0) isFind = true;
    
                revertPosOfCmp(doorsArray, wallName)
    
                if((doorRef.current.position.x < limitX.min || doorRef.current.position.x > limitX.max)) {
                    isSetPosition = false;
                } else {
                    isSetPosition = true;
                }
    
                revertPosOfCmp(doorsArray, wallName)
                
                if (isFind || !isSetPosition) {
                    setPositionX(startPositionXY.x);
                    doorRef.current.position.x = startPositionXY.x
                    setPositionY(startPositionXY.y);
                    doorRef.current.position.y = startPositionXY.y
                } else {
                    setStartPositionXY({ x: doorRef.current.position.x, y: positionY });
                    dispatch(actionCreator.updateDoorWindowPosition(id, doorRef.current.position.x, positionY));
                    dispatch(actionCreator.updateDoorWindowLimitPosition(id, limitX.min, limitX.max));
                }
            }
    
            let intersectWall = scene.getObjectByName("intersectWall")
            let intersectLeg = scene.getObjectByName("intersectLeg")
            
            if(intersectWall != undefined){
                scene.remove(intersectWall)
                scene.remove(intersectLeg)
            }
    
            setIsDrag(false)
            isDraggable = false
            if(event.pointerType == "mouse"){
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);
            }else{
                document.addEventListener("touchmove", handleMouseMove);
                document.addEventListener("touchend", handleMouseUp);
            }
    
        };

        if(event.pointerType == "mouse"){
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
        }else{
            document.addEventListener("touchmove", handleMouseMove);
            document.addEventListener("touchend", handleMouseUp);
        }

      
    };


    return isAvailablePlace && (
        <group rotation={[0, rotationY, 0]}>
            <group
                position={[isDrag ? positionX : defaultPositionX, positionY, isDrag ? positionZ + 0.3 : positionZ]}
                // {...bind()}
                ref={doorRef}
                onClick={onClickDoorComponent}
                onPointerOver={() => {
                    let isDoorTransparent = checkDoorTransparent();
                    setCanClone(true);
                    if ((controls.isCheckActiveTab !== 'leantos') && (((controls.isCheckActiveTab === 'doorwindow' || params.is_translusant) ? (!isDoorTransparent) : true)) && const_var.controls.enableRotate) {
                        setIsHovered(true)
                        
                    }
                }}
                onPointerOut={() => setIsHovered(false)}
                name={`${compName}_${wallName}_${id}_DoorWindows`}
                userData={{"section":wallnameBySec[wallName]}}
                onPointerDown={e=>handleMouseDown(e)}
            >
                <group name='Measurements-door' position={[0, 0, isDrag ? -0.3 : 0]} {...eventHandlers}>
                    <DoorMeasurements compType={compType} isDrag={isDrag} bindDelta={bindDelta} positionX={positionX} positionY={positionY} positionZ={positionZ} height={height} width={width} wallName={wallName} id={id} /* opacityValue={opacityValue} transparentState={transparentState} *//>
                </group>

                {/********* Walk In Door **********/}
                {compName === 'standard_walkin' && compType === 'walkin_frameout' && <WalkInFrameoutDoor width={width} height={height} trimWidth={trimWidth} trimColor={trimColor} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'standard_walkin' && compType !== 'walkin_frameout' && <StandardWalkInDoor handlePlacement={"left"} width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === 'home_door_with_right_knob_walkin' && compType !== 'walkin_frameout' && <StandardWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === 'diamond_window_walkin' && <DiamondWindowWalkInDoor handlePlacement={"left"} width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '11_lite_walkin' && <ElevenLiteWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '5_lite_plan_door_walkin' && <FiveLitePlanWalkInDoor handlePlacement={"left"} width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName.includes('5_lite') && <FiveLiteWalkInDoor handlePlacement={compName.includes('right') ?"right": "left"} width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '4_lite_walkin' && <FourLiteWalkInDoor handlePlacement={"left"} width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === 'french_door_walkin' && <FrenchDoorWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '9_lite_walkin' && <NineLiteWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '9_lite_plan_door_walkin' && <NineLitePlainWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName.includes('plan_9_lite') && <NineLitePlainWalkInDoor handlePlacement={compName.includes('right') ? "left": "right"} width={width} height={height} trimWidth={trimWidth} doorColor={compName.includes('black')? "#1F1F1F": doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName.includes('panel_9_lite') && <NineLitePanelWalkInDoor handlePlacement={compName.includes('right') ? "left": "right"} width={width} height={height} trimWidth={trimWidth} doorColor={compName.includes('black')? "#1F1F1F": doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '6_lite_walkin' && <SixLiteWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === 'solid_walkin' && <SolidWalkInDoor handlePlacement={"left"} width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === 'solid_l_swing_walkin' && <SolidWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '9_lite_l_swing_walkin' && <NineLiteWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '9_lite_panel_door_right_knob_walkin' && <NineLiteWalkInDoor handlePlacement={"left"} width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === 'diamond_window_rights_walkin' && <DiamondWindowWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }

                {/********* Double Door **********/}
                {compName === 'standard_door' && compType === 'garage_door_frameout' && <GarageDoorFrameoutDoor width={width} height={height} trimWidth={trimWidth} trimColor={trimColor} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'standard_door' && compType !== 'garage_door_frameout' && <RollUpDoor width={width} height={height} trimWidth={trimWidth} trimColor={trimColor} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */ /> }
                {compName === "standard_trim_door" && compType === "garage_door_frameout" && <GarageDoorFrameoutDoorDegree width={width} height={height} trimWidth={trimWidth} trimColor={trimColor} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */ /> }
                {compName === "standard_trim_door" && compType !== "garage_door_frameout" && <RollUpDoorDegree width={width} height={height} trimWidth={trimWidth} trimColor={trimColor} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */ /> }
                {compName === 'double_slider_door_door' && <DoubleSliderDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'double_door_walkin' && <DoubleDoorWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */ /> }
                {compName === 'double_delux_walkin' && <DoubleDeluxWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === '15_lite_double_door_walkin' && <FifteenLiteDoubleDoorWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {compName === '9_lite_double_door_walkin' && <NineLiteDoubleDoorWalkInDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} */  /> }
                {(compName === 'sectional_door' || compName === "overhead_door_door_no_glass") && <SectionalDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'sectional_with_window_door' && <SectionalWithWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_plain_glass" && <SectionalWithPlainWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_sherwood" && <SectionalWithSherwoodWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_williamsburg" && <SectionalWithWilliamsburgWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_cascade" && <SectionalWithCascadeWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_cathedral" && <SectionalWithCathedralWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_stockton" && <SectionalWithStocktonWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_stockbridge" && <SectionalWithStockbridgeWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_prairie" && <SectionalWithPrairieWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === "overhead_door_door_waterton" && <SectionalWithWatertonWindowDoor width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }

                {selectedCmpType === 'door' && isShowEditIconSection && const_var.doorUniqueId === id && !isDoorTransparent && /* !transparentState && */ (
                    <Html key={occludeState} ref={editRef} position={[width / 1.95, height / 1.73, 1]} className='edit-btn-section' occlude={occludeState}>
                        <div onClick={() => {setCanClone(true); setIsDelBtnClicked(false); onClickEditButton()}} className='edit-icon-container'>
                            {
                                !const_var.showComponentEditBox ?
                                <i className='ico-icon-edit-ico'></i>:
                                <i className='ico-icon-close'></i>
                            }
                        </div>
                        <div onClick={(e) => {setDelTooltipPosition(e); setCanClone(true); setIsDelBtnClicked(true)}}  className='delete-icon-container'>
                            <i className='ico-icon-delete' style={{color: isDelBtnClicked ? '#D5121A' : '#000000'}}></i>
                            {
                                isDelBtnClicked &&
                                <div className={`delete-tooltip ${delPosition} `}>
                                    <div className="alert-title">ALERT!!</div>
                                    <div className="alert-content">{`Are you sure you want to delete this ${(compType === 'garage_door_frameout' || compType === 'walkin_frameout') ? "frameout" : "door"}?`}</div>
                                    <button className="btn btn-danger" onClick={(e) => dispatch(actionCreator.removeComponent(const_var.doorUniqueId))}>
                                        YES DELETE
                                    </button>
                                    <i className='ico-icon-close' onClick={(e) => {e.stopPropagation(); handleDeleteClick(false)}}></i>
                                </div>
                            }
                        </div>
                        <div onClick={(e)=> {setWarnTooltipPosition(e);  setIsDelBtnClicked(false); cloneComponent(const_var.doorUniqueId, e)}} className='clone-icon-container' >
                            <i className='ico-icon-duplicate-ico' style={{color: !canClone ? '#FF8900' : '#000000'}}></i>
                            {
                                !canClone &&
                                <div className={`warning-tooltip ${warnPosition}`}>
                                    <div className='warning-content'>This item doesn’t fit and can’t be placed on the selected wall.</div>
                                    <i className='ico-icon-close' onClick={(e) => {e.stopPropagation(); handleSetCanClone();}}></i>
                                </div>
                            }
                        </div>
                    </Html>
                )}

                {((isDrag) || (isHovered) || (selectedCmpType === 'door' && isShowEditIconSection && const_var.doorUniqueId === id && !isDoorTransparent /* && !transparentState */)) && <DoorOutLineSection width={width} height={height} isDeleted={isDelBtnClicked} canClone={canClone}/>}

                {
                    isCloned && 
                    <Html className='clone-success-container' position={addedDoorPos}>
                        <div>
                            <span>
                                {'Door Cloned Successfully'}
                            </span>
                            <span>
                                <i className='ico-icon-close' onClick={() => setIsCloned(false)}></i>
                            </span>
                        </div>
                    </Html>
                }

            </group>
        </group>
    )
}

export default DoorModel